import { useCallback, useEffect, useEffectEvent, useState } from 'react';

const defaultUnlockTime = 30 * 1000; // 30 secs

export const useBlockClick = (props?: { unlockTime?: number }) => {
	const unlockTime = props?.unlockTime || defaultUnlockTime;
	const [clicked, setClicked] = useState(false);

	const startUnlockTimer = useEffectEvent(() =>
		setTimeout(() => {
			setClicked(false);
		}, unlockTime)
	);

	useEffect(() => {
		if (clicked) {
			const timeoutRef = startUnlockTimer();
			return () => clearTimeout(timeoutRef);
		}

		return undefined;
	}, [clicked]);

	const handleClick = useCallback(() => {
		setClicked(true);
	}, []);

	return {
		disabled: clicked,
		handleClick,
	};
};
